import { ProgramAction, ProgramActionType } from '../actions/ProgramActions';
import { Program } from '../types';

const programReducer = (state: Array<Program> = [], action: ProgramAction) => {
    switch (action.type) {
        case ProgramActionType.GET_ALL_PROGRAMS:
        case ProgramActionType.GET_ALL_ADMIN_PROGRAMS:
            return action.payload;
        case ProgramActionType.CREATE_PROGRAM:
            return [...state, action.payload];
        case ProgramActionType.GET_PROGRAM:
        case ProgramActionType.DELETE_PROGRAMS:
        case ProgramActionType.MERGE_PROGRAMS:
        case ProgramActionType.UPDATE_PROGRAM:
            return state.map((program: Program) => {
                const newProgram = action.payload as Program;
                if (program._id === newProgram._id) {
                    return newProgram;
                } else {
                    return program;
                }
            });
        default:
            return state;
    }
};

export default programReducer;
